import type { DownloadLink } from "@oysterhr/schema"
import { FileStatus } from "~/shared/hooks/useFileUploadComponent/utils"
import type { FilePayload } from "~/shared/hooks/useFileUploadComponent/types"

export const fileUploadToDownloadLink = (file: Partial<FilePayload>) => {
  return {
    filename: file?.file?.name || "Unkown file name",
    url: file.href,
    documentId: file?.signedId || "",
    byteSize: file?.file?.size || 0,
    contentType: file?.file?.type || "",
    createdAt: file?.file?.lastModified || 0,
  }
}
export const downloadLinkToFileUpload = (file: Partial<DownloadLink>) => {
  return {
    file: {
      name: file.filename || "Unkown file name",
      size: file.byteSize || 0,
      type: file.contentType || "",
      lastModified: file.createdAt || 0,
    } as File,
    status: FileStatus.Uploaded,
    href: file.url || "",
    signedId: file.documentId || "",
  }
}
